import script from "./FileControl.vue?vue&type=script&setup=true&lang=js"
export * from "./FileControl.vue?vue&type=script&setup=true&lang=js"

import "./FileControl.vue?vue&type=style&index=0&id=365aad3a&lang=css"
import "./FileControl.vue?vue&type=style&index=1&id=365aad3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-365aad3a"]])

export default __exports__